import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { SharedService } from '@app/services/shared.service';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  isExpanded = false;
  isMenuOpened = false;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private meta: Meta,
    private versionCheckService: VersionCheckService
  ) {
    // mobile menu is being collapsed on route change
    router.events.subscribe(() => {
      this.isMenuOpened = false;
    });

    this.setBodyClass(!!localStorage.getItem('[Safety] Dark Theme') ? 'dark' : 'light');
  }

  get isBuildDev(): boolean {
    return ['localhost', '127.0.0.1'].includes(location.hostname);
  }

  ngOnInit() {
    this.sharedService.getIsExpanded().subscribe((isExpanded: boolean) => {
      this.isExpanded = isExpanded;
    });
    this.meta.updateTag({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
    });

    this.versionCheckService.initVersionCheck(60000);
  }

  toggleMenu(): void {
    this.isExpanded = !this.isExpanded;
    this.sharedService.setIsExpanded(this.isExpanded);
  }

  toggleMobileMenu(): void {
    this.isMenuOpened = !this.isMenuOpened;
    this.isMenuOpened ? this.sharedService.setIsExpanded(true) : null;
    // Block body scroll when menu is opened
    document.body.style.overflow = this.isMenuOpened ? 'hidden' : 'visible';
  }

  setBodyClass(theme: string): void {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
  }
}
